import { render, staticRenderFns } from "./AddRegister.vue?vue&type=template&id=c70f4688&scoped=true&"
import script from "./AddRegister.vue?vue&type=script&lang=js&"
export * from "./AddRegister.vue?vue&type=script&lang=js&"
import style0 from "./AddRegister.vue?vue&type=style&index=0&id=c70f4688&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70f4688",
  null
  
)

export default component.exports